import {ICue} from "./LocalizedSubtitles";
import {ChangeEvent} from "react";
import {Box, IconButton, ListItem, TextField} from "@mui/material";
import {ArrowDropDown, ArrowDropUp, Delete} from "@mui/icons-material";

interface ISubtitleCue {
    count: number
    cue: ICue
    index: number
    onDelete: (index: number) => void
    onMove: (from: number, to: number) => void
    onUpdate: () => void
}
export function SubtitleCue({count, cue, index, onDelete, onMove, onUpdate}: ISubtitleCue) {
    const handleMemberChange = (member: "start" | "stop") => ({target}: ChangeEvent<HTMLInputElement>) => {
        cue[member] = Number(target.value)
        onUpdate();
    }
    const handleTextChange = ({target}: ChangeEvent<HTMLInputElement>) => {
        cue.text = target.value
        onUpdate();
    }
    const handleMoveClick = (direction: number) => () => onMove(index, index + direction);

    return (
        <ListItem disableGutters>
            <Box display="flex">
                <Box display="flex" flexDirection="column">
                    <IconButton color="primary" disabled={index === 0} onClick={handleMoveClick(-1)}
                                size="small" sx={{padding:0}}>
                        <ArrowDropUp fontSize="inherit"/>
                    </IconButton>
                    <IconButton color="primary" disabled={index === count - 1} onClick={handleMoveClick(1)}
                                size="small" sx={{padding:0}}>
                        <ArrowDropDown fontSize="inherit"/>
                    </IconButton>
                </Box>
                <TextField label="Start" onChange={handleMemberChange("start")} size="small"
                           sx={{width: 150, marginRight: 1}} type="number" value={cue.start}/>
                <TextField label="Stop" onChange={handleMemberChange("stop")} size="small"
                           sx={{width: 150, marginRight: 1}} type="number" value={cue.stop}/>
                <TextField fullWidth label="Text" onChange={handleTextChange} size="small"
                           sx={{flexGrow: 1}} value={cue.text}/>
                <IconButton color="primary" onClick={() => onDelete(index)}>
                    <Delete/>
                </IconButton>
            </Box>
        </ListItem>
    );
}
